(function () {
class PredictiveSearch extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector("[data-predictive-search-results]") || this.querySelector("#predictive-search");

		if (!this.input || !this.predictiveSearchResults) return;

		this.input.setAttribute("aria-expanded", "false");
		if (this.predictiveSearchResults.id) {
			this.input.setAttribute("aria-controls", this.predictiveSearchResults.id);
		}

		this.input.addEventListener(
			"input",
			this.debounce((event) => {
				this.onChange(event);
			}, 300).bind(this)
		);

    const searchMobileButton = document.querySelector('[data-search-mobile]')
    if (searchMobileButton) {
      searchMobileButton.addEventListener('click', () => {
        this.input.focus()
      })
    }

		this.onViewportChange = this.setResultsMaxHeight.bind(this);
		if (window.visualViewport) {
			window.visualViewport.addEventListener("resize", this.onViewportChange);
			window.visualViewport.addEventListener("scroll", this.onViewportChange);
		}
	}

	setResultsMaxHeight() {
		if (!this.predictiveSearchResults || this.input.getAttribute("aria-expanded") !== "true") return;

		const vv = window.visualViewport;
		if (!vv) return;

		const top = this.predictiveSearchResults.getBoundingClientRect().top - vv.offsetTop;
		const available = Math.max(vv.height - top - 8, 160);
		this.predictiveSearchResults.style.setProperty("--predictive-search-max-height", `${available}px`);
	}

	onChange() {
		const searchTerm = this.input.value.trim();

		if (!searchTerm.length) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	getSearchResults(searchTerm) {
		fetch(
			`${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[limit_scope]=each&section_id=predictive-search`
		)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}
				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser()
					.parseFromString(text, "text/html")
					.querySelector("#shopify-section-predictive-search").innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				this.open();
			})
			.catch((error) => {
				this.close();
				throw error;
			});
	}

	open() {
		this.predictiveSearchResults.style.display = "block";
		this.input.setAttribute("aria-expanded", "true");
		this.setResultsMaxHeight();
		this.closest(".section-header")?.classList.add("predictive-search-open");
	}

	close() {
		this.predictiveSearchResults.style.display = "none";
		this.input.setAttribute("aria-expanded", "false");

		const sectionHeader = this.closest(".section-header");
		if (sectionHeader && !sectionHeader.querySelector('input[aria-expanded="true"]')) {
			sectionHeader.classList.remove("predictive-search-open");
		}
	}

	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}

if (!customElements.get("predictive-search")) {
	customElements.define("predictive-search", PredictiveSearch);
}
})();
